module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/it-card-drag.02ad166675d935c80f45.gif";